
import Vue from "vue";

export default Vue.extend({
	props: {
		shrink: Boolean,
		block: Boolean,
		grow: Boolean,
		noMargin: Boolean,
		stretch: Boolean,
		center: Boolean,
		noWrap: Boolean,
		reverse: Boolean
	}
});
